
export default function AboutSection() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="rounded-3xl border-2 border-gold overflow-hidden relative h-[500px] w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/9649d70b7692255e674d4c8452192dd5.jpg"
                alt="NEXTLIFE Asset Sales facility"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gold/30 to-transparent"></div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center px-4 py-2 border border-gold rounded-full bg-transparent mb-6">
              <span className="text-gold text-xs tracking-[2px] uppercase font-semibold">
                About NEXTLIFE
              </span>
            </div>

            <h2 className="text-white text-4xl md:text-5xl font-bold leading-tight mb-6">
              Sustainable Asset<br />Cycles & Professional<br />Remarketing
            </h2>

            <p className="text-lightGray text-lg leading-relaxed mb-8">
              Based in Downey, California, NEXTLIFE ASSET SALES LLC is dedicated to extending the lifecycle of industrial and commercial assets through strategic remarketing and professional liquidation services.
            </p>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-gold text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                <div>
                  <p className="text-white font-semibold">Location</p>
                  <p className="text-lightGray text-sm">12215 Morning Ave, Downey, CA 90242</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <i className="ri-phone-line text-gold text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                <div>
                  <p className="text-white font-semibold">Phone</p>
                  <a href="tel:408-581-3979" className="text-gold hover:text-warmGold transition-colors text-sm cursor-pointer">
                    408-581-3979
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <i className="ri-mail-line text-gold text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                <div>
                  <p className="text-white font-semibold">Email</p>
                  <a href="mailto:edgarg@nextlifeasset.com" className="text-gold hover:text-warmGold transition-colors text-sm cursor-pointer">
                    edgarg@nextlifeasset.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
